	function ContactFormSettlingIn(settings){
		this.setup(settings);
	}
	ContactFormSettlingIn.inheritsFrom( ContactForm );
	ContactFormSettlingIn.prototype.instructions = function(){
		return {
			pages: [
				{	name: "index", 		questions: ['settling-type'] },
				// {
				// 	name: "questions", 	questions: ['moving-house-from','moving-house-to'],
				// 	include: (e) => {
				// 		const settlingType = this.values['settling-type'];

				// 		// IF (SINGLE-PROPERTY || PORTFOLIO || RENTALS) && (OCCUPIED || MIXED)
				// 		return (settlingType === "moving-house");
				// 	}
				// },
				// {
				// 	name: "questions",	questions: ['home-organisation-property'],
				// 	include: (e) => {
				// 		const settlingType = this.values['settling-type'];

				// 		// IF (SINGLE-PROPERTY || PORTFOLIO || RENTALS) && (OCCUPIED || MIXED)
				// 		return (settlingType === "home-organisation-property");
				// 	}
				// },
				// {
				// 	name: "questions",	questions: ['home-organisation-where'],
				// 	include: (e) => {
				// 		const settlingType = this.values['settling-type'];

				// 		// IF (SINGLE-PROPERTY || PORTFOLIO || RENTALS) && (OCCUPIED || MIXED)
				// 		return (settlingType === "home-organisation");
				// 	}
				// },
				// {	name: "questions",	questions: ['property-rooms'],
				// 	include: (e) => {
				// 		const movingHouseFrom = this.values['moving-house-from'];
				// 		const movingHouseTo = this.values['moving-house-to'];
				// 		const houseLocation = this.values['home-organisation-where'];

				// 		// IF (SINGLE-PROPERTY || PORTFOLIO || RENTALS) && (OCCUPIED || MIXED)
				// 		return (
				// 				((movingHouseFrom != "") && (movingHouseTo != "")) || (houseLocation != "")
				// 			);
				// 	}
				//  },
				// {	name: "questions",	questions: ['help'],
				// 	include: (e) => {
				// 		const propertyRooms = this.values['property-rooms'];

				// 		// IF (SINGLE-PROPERTY || PORTFOLIO || RENTALS) && (OCCUPIED || MIXED)
				// 		return (propertyRooms != "" );
				// 	}
				// },
				{ 	name: "details1",	questions: ['full-name'],
					include: (e) => {
						const type = this.values['settling-type'];
						return (type != "");
					}
				},
				{ 	name: "details2",	questions: ['email'],
					include: (e) => {
						this.values.contact === "email"
						const type = this.values['settling-type'];
						return (type != "");
					}
				},
				{ 
					name: "details3",	questions: ['phone'],
					include: (e) => {
						this.values.contact === "phone"
						const type = this.values['settling-type'];
						return (type != "");
					}
				},
				{ 
					name: "details4",	questions: ['your-requirements'], 
					include: (e) => {
						const type = this.values['settling-type'];
						return (type != "");
					}
				}
			],
			questions: [
				{
					name: "settling-type",
					input: "buttons",
					inputType: "single",
					required: true,
					labels: "Are you or your client moving house or do you require other home organisation services?\n",
					answers: [
						{ labels: "Moving house", 		name: "moving-house"},
						{ labels: 'Home organisation', 	name: "home-organisation"}
					],
				},
				// {
				// 	name: "moving-house-from",
				// 	input: "buttons",
				// 	inputType: "single",
				// 	required: false,
				// 	labels: "Where are you or your client moving from?",
				// 	answers: [
				// 		{ labels: "The London Area", 	name: "the-london-area" },
				// 		{ labels: 'The UK', 			name: "uk" },
				// 		{ labels: 'Europe', 			name: "europe" },
				// 		{ labels: 'USA', 				name: "usa" },
				// 		{ labels: 'Elsewhere', 			name: "elsewhere" }
				// 	],
				// },{
				// 	name: "moving-house-to",
				// 	input: "textarea",
				// 	required: false,
				// 	labels: "Where are you or your client moving to?",
				// 	placeholder: "Please enter the area",
				// },{
				// 	name: "home-organisation-property",
				// 	input: "textarea",
				// 	required: false,
				// 	labels: "Where is the property you or your client would like help with?",
				// },{
				// 	name: "home-organisation-property-area",
				// 	input: "textarea",
				// 	required: true,
				// 	labels: "Please enter the area",
				// },{
				// 	name: "home-organisation-where",
				// 	input: "textarea",
				// 	required: false,
				// 	labels: "Where is the house you would like help organising?",
				// 	placeholder: "Please enter the area",
				// },{
				// 	name: "area",
				// 	input: "textarea",
				// 	required: true,
				// 	labels: "Please enter the area",
				// },{
				// 	name: "property-rooms",
				// 	input: "buttons",
				// 	inputType: "single",
				// 	required: true,
				// 	labels: "How many bedrooms does the property have?",
				// 	answers: [
				// 		{ labels: "1 - 3",		name: "1-3" },
				// 		{ labels: "4 - 7", 		name: "4-7" },
				// 		{ labels: "8 - 11", 	name: "8-11" },
				// 		{ labels: "12+", 		name: "12+" },
				// 	],
				// },
				// {
				// 	name: "help",
				// 	input: "buttons",
				// 	inputType: "multiple",
				// 	required: true,
				// 	labels: "What are you interested in getting help with?",
				// 	answers: [
				// 		{ labels: "Packing & Unpacking",				name: "packing-unpacking" },
				// 		{ labels: "Home setup & installation",			name: "home-setup-installation" },
				// 		{ labels: "Decluttering & organisation",		name: "decluttering-organisation" },
				// 		{ labels: "Hiring household staff",				name: "hiring-household-staff" },
				// 		{ labels: "Home manual creation",				name: "home-manual-creation" },
				// 		{ labels: "International settling-in program",	name: "international-settling-in-program" },
				// 		{ labels: "Other", 								name: "other" },
				// 	],
				// },
				{
					name: "full-name",
					input: "text",
					required: true,
					labels: "Please tell us your name",
					placeholder: "Type your name here",
				},{
					name: "email",
					input: "text",
					required: false,
					labels: "Please enter your email address",
					placeholder: "Type your email address",
				},{
					name: "phone",
					input: "text",
					required: false,
					labels: "Please enter your phone number",
					placeholder: "Type your phone number",
				},
				{
					name: "your-requirements",
					input: "textarea",
					required: false,
					labels: "Further information you would like to share",
					placeholder: "Type further information here",
				}						
			]
		}
	}
